import { render, staticRenderFns } from "./MentionSuggestionList.vue?vue&type=template&id=0ba7f85e&scoped=true"
import script from "./MentionSuggestionList.vue?vue&type=script&lang=ts"
export * from "./MentionSuggestionList.vue?vue&type=script&lang=ts"
import style0 from "./MentionSuggestionList.vue?vue&type=style&index=0&id=0ba7f85e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba7f85e",
  null
  
)

export default component.exports